<template>
    <div>
        <vue-editor v-model="content" :editorToolbar="customToolbar" class="bg-white position-relative border border-radius-4 f-14" :placeholder="$ml.get('ENTER_A_NOTE')"></vue-editor>
        <div class="row justify-content-end noteBtnStyle mt-3 m-0" v-if="method!=='save'">
            <button class="btn btn-new" @click="clearEditor">{{$ml.get('CANCEL')}}</button>
            <button class="btn btn-new save" @click="save">{{$ml.get('SAVE')}}</button>
        </div>
        <div class="row justify-content-end noteBtnStyle mt-3 m-0" v-if="specialStatu">
            <button class="btn btn-new" @click="clearEditor">{{$ml.get('CANCEL')}}</button>
            <button class="btn btn-new save" @click="activityNoteSave">{{$ml.get('SAVE')}}</button>
        </div>
        <i class="icon-line-iptal position-absolute d-none" style="right: 10px;top: 5px;"></i>
        <!-- <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" /> -->
    </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import { VueEditor, Quill } from 'vue2-editor'
export default {
  name: 'addNotePanel',
    data () {
        return {
            content:"",
            customToolbar:[
                [{ 'font': [] },'bold', 'italic', 'underline', 'strike'],
                /*
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                [{ 'color': [] }, { 'background': [] }],
                ['link','clean'],
                */
            ],
            update:false,
            addData:[]
        }
    },
    components: {
        VueEditor,
    },
    computed: {
        ...mapState([
            'baseUrl',
            'editLineStatu'
        ]),
        listenStateStatus() { return this.$store.state.editLineStatu},
    },
    props:["data","activityNote","postField","method","activityId","specialStatu","permission"],
    methods:{
        clearEditor(){
            this.content=""
            $("#noteAdd").modal('hide')
        },
        permissionSet(){
            if(this.permission===true){
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: this.$ml.get('YOU_ARE_NOT_AUTHORIZED')
                })
                return true
            }else{
                return false
            }
        },
        save(){
            if(this.permissionSet()){
                return false
            }
            let dataObje={}
            let url=""
            if(this.postField==="deal"){
                url="upsertDealNote"
                dataObje['dealId']=this.data._id.$oid
            }else if(this.postField==="organization"){
                url="upsertOrganizationNote"
                dataObje['organizationId']=this.data._id.$oid
            }else if(this.postField==="contact"){
                url="addNote"
                dataObje['contactId']=this.data._id.$oid
            }else if(this.postField==="activities"){
                url="upsertActivityNote"
                dataObje['activityId']=this.data._id.$oid
            }
            dataObje['noteText']=this.content
            dataObje['note']=this.content
            dataObje['notePostUrl']=url
            if(this.content===""){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: this.$ml.get('NOTES_CANNOT_BE_BLANK'),
                    text:this.$ml.get('PLEASE_ADD_A_VALID_NOTE')
                })
                return false
            }
             
            axios({
                method:'POST',
                url:'/addNote',
                baseURL: this.baseUrl,
                data: dataObje,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.content=""
                    this.newData=res.data.content.note
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc
                    })
                    if(this.postField==="deal"){
                        this.$emit('updateDealNote',this.newData)
                    }else if(this.postField==="organization") {
                        this.$emit('updateOrgNote',this.newData)
                    }else if(this.postField==="contact") {
                        this.newData=res.data.content
                        this.$emit('updateContactNote',this.newData)
                    }
                        $('#noteAdd').modal("hide")
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        activityNoteSave(){
             
            if(this.content.length>0){
                axios({
                    method:'POST',
                    url:'/upsertActivityNote',
                    baseURL: this.baseUrl,
                    data: {
                        activityId:this.activityId,
                        noteText:this.content
                    },
                    withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.data.status.code==0){
                        this.content=""
                        this.addData=res.data.content.note
                        this.$emit('addNote',this.addData)
                        this.update=true
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.data.status.desc
                        })
                         
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'warning', 
                            title: this.$ml.get('ERROR'),
                            text: res.data.status.desc
                        })
                         
                    }
                })
            }
        },
        ...mapActions([
            'updateLoading'
        ]),
    },
    created(){
        this.content=""
    },
    watch: {
        content:function(value) {
            if(this.activityId==''){
                this.$emit('returnNote',value)
            }
            
        },
        listenStateStatus(data){
            if(data===false){
                this.content=""
            }
        },
        activityNote:function(value){
            if(value!==undefined){
                this.content=value
            }
        }
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
